import { useSelector } from "react-redux";
import { selectCurrentagency } from "../redux/features/authSlice";
import { AREA_UNITS_BY_COUNTRY, UAE_AREA_UNITS } from "../constants/area";

export default function useAreaUnits() {
  const currentAgency = useSelector(selectCurrentagency);

  const countryid = currentAgency?.countryid;

  return AREA_UNITS_BY_COUNTRY[countryid] ?? UAE_AREA_UNITS;
}
